import { createContext, useContext } from 'react'

export type ToastTone = 'ok' | 'warn' | 'err'

export interface ToastMessage {
  id: number
  text: string
  tone: ToastTone
}

export interface ToastApi {
  /** Fire and forget; the provider clears it. Scanning never waits on a toast. */
  show: (text: string, tone?: ToastTone) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

export function useToast(): ToastApi {
  const context = useContext(ToastContext)

  if (context === null) {
    throw new Error('useToast must be used inside ToastProvider')
  }

  return context
}
